<template>
    <div>
        <VcPopover trigger="click">
            <template #reference>
                <div class="cursor-pointer text-blue-600 underline">
                    {{ 'JSON' }}
                </div>
            </template>
            <div class="p-2">
                <pre>{{ formatted }}</pre>
            </div>
        </VcPopover>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { VcPopover } from '@voicenter-team/voicenter-ui-plus'

const props = defineProps<{ value: string }>()

const formatted = computed(() => {
    try {
        return JSON.stringify(JSON.parse(props.value), null, 2)
    } catch {
        return props.value
    }
})
</script>
